import { ArrowDownSmallIcon } from '@blocksuite/icons/lit';

export const SmallArrowDownIcon = ArrowDownSmallIcon({
  width: '16',
  height: '16',
});
